module.exports = require('./helpers/bundle-url').getBundleURL('huCuf') + "logo.c51670a8.svg";